/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuthenticationResponseStatus {
  Success = 0,
  ExpiredLoginLink = 2,
  InactiveLoginLink = 3,
  InvalidPhoneNumber = 4,
  InvalidOrExpiredAdminLoginSessionId = 5,
  EmailIsNotValidOrCredentialsDoNotMatch = 6,
  InactiveUser = 7,
  ShouldFollowInvitationLink = 8,
  ShouldRequestNewInvitationLink = 9,
  InactiveAccount = 10,
}
